// Registration codes whose accounts get the custom upload portal: one document per lesson plan,
// analysed as a whole (aggregate lesson analysis) instead of per-document mapping.
// Keep in sync with CUSTOM_UPLOAD_PORTAL_CODES in classcompass-backend/src/utils/registrationCodes.js.
export const CUSTOM_UPLOAD_PORTAL_CODES = [
    'WILLIAM FORD R_2026',
    'GAINSBOROUGH R_2627',
];

export const normalizeRegistrationCode = (code) => {
    if (!code) return '';
    return code.toString().trim().replace(/\s+/g, ' ').toUpperCase();
};

export const usesCustomUploadPortal = (code) =>
    CUSTOM_UPLOAD_PORTAL_CODES.includes(normalizeRegistrationCode(code));
